export default {
  mainChamber: 'Ofenübersicht',
  chamber: 'Kammer {subSystemId}',
};
